/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoInvoiceFormDefaultsDto
 */
export interface WebApiAdminDtoInvoiceFormDefaultsDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceFormDefaultsDto
     */
    nextInvoiceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceFormDefaultsDto
     */
    customerReferenceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceFormDefaultsDto
     */
    customerReferenceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceFormDefaultsDto
     */
    customerReferenceZipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceFormDefaultsDto
     */
    customerReferenceCity?: string | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoInvoiceFormDefaultsDto interface.
 */
export function instanceOfWebApiAdminDtoInvoiceFormDefaultsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoInvoiceFormDefaultsDtoFromJSON(json: any): WebApiAdminDtoInvoiceFormDefaultsDto {
    return WebApiAdminDtoInvoiceFormDefaultsDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoInvoiceFormDefaultsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoInvoiceFormDefaultsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextInvoiceNumber': !exists(json, 'nextInvoiceNumber') ? undefined : json['nextInvoiceNumber'],
        'customerReferenceName': !exists(json, 'customerReferenceName') ? undefined : json['customerReferenceName'],
        'customerReferenceAddress': !exists(json, 'customerReferenceAddress') ? undefined : json['customerReferenceAddress'],
        'customerReferenceZipCode': !exists(json, 'customerReferenceZipCode') ? undefined : json['customerReferenceZipCode'],
        'customerReferenceCity': !exists(json, 'customerReferenceCity') ? undefined : json['customerReferenceCity'],
    };
}

export function WebApiAdminDtoInvoiceFormDefaultsDtoToJSON(value?: WebApiAdminDtoInvoiceFormDefaultsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextInvoiceNumber': value.nextInvoiceNumber,
        'customerReferenceName': value.customerReferenceName,
        'customerReferenceAddress': value.customerReferenceAddress,
        'customerReferenceZipCode': value.customerReferenceZipCode,
        'customerReferenceCity': value.customerReferenceCity,
    };
}

